import { render } from "./Buttons.vue?vue&type=template&id=e8d67b44&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"

import "./Buttons.vue?vue&type=style&index=0&id=e8d67b44&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d67b44"]])

export default __exports__